export const heroImage =
  'https://cdn.magicpatterns.com/uploads/w5eMd8QZqhki5gpWmB4css/Imagen_de_ChatGPT_27_sept_2026,_00_29_47-Photoroom.webp'

/** Link di pagamento. */
export const checkoutUrl = 'https://atletica-360.impultienda.ar/checkout'
export const brandName = 'Atletica 360'
export const price = '€19'
export const fullPrice = '€197'
export const volumesValue = '€120'
export const bonusValue = '€77'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Volumi tecnici' },
  { value: '70+', label: 'Sessioni pronte' },
  { value: '5', label: 'Bonus esclusivi' },
]

export const heroBadges: string[] = [
  '100% in italiano',
  'Accesso immediato',
  'PDF scaricabile',
  'Garanzia 7 giorni',
]

/** Il costo reale di non avere il sistema corretto. */
export interface Cost {
  title: string
  detail: string
}

export const costs: Cost[] = [
  {
    title: 'Ore di pianificazione ogni settimana',
    detail:
      "Il tuo tempo libero scompare prima ancora che l'allenamento cominci.",
  },
  {
    title: 'Ripeti gli stessi esercizi perché sono facili',
    detail: 'I tuoi atleti smettono di migliorare. La varietà scompare.',
  },
  {
    title: 'Esercizi senza una vera progressione tecnica',
    detail: "L'allenamento diventa confuso invece di essere produttivo.",
  },
  {
    title: 'Non sai come correggere la tecnica nel momento',
    detail: "Vedi l'errore ma non hai la progressione pronta per risolverlo.",
  },
  {
    title: 'Gruppi misti in competizione per la tua attenzione',
    detail: 'La pianificazione diventa un caos.',
  },
  {
    title: 'Settimane di gara improvvisate da zero',
    detail: "Non sai se l'atleta è fresco o sovraccarico.",
  },
]

/** Cosa include l'accesso completo. */
export const included: string[] = [
  '6 volumi tecnici',
  "70+ sessioni pronte all'uso",
  `5 bonus esclusivi (valore ${bonusValue})`,
  '100% in italiano',
  'Accesso immediato in PDF',
  'Garanzia di 7 giorni',
]

/** La chiusura: cosa succede se continui a improvvisare e cosa ottieni. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Altre 4 ore domenicali a cercare esercizi', positive: false },
  { text: 'Nessuna progressione tecnica vera', positive: false },
  { text: 'Atleti che si annoiano e migliorano lentamente', positive: false },
  { text: 'Pista disorganizzata', positive: false },
  { text: 'Senza un sistema, sempre lo stesso stress', positive: false },
  { text: '5 minuti per pianificare una sessione completa', positive: true },
  { text: 'Progressioni coerenti da principiante a élite', positive: true },
  { text: 'Atleti motivati che migliorano visibilmente', positive: true },
  { text: 'Pista ordinata con tre livelli simultanei', positive: true },
  { text: 'Autorità tecnica, sicurezza e pace mentale', positive: true },
]
